// extracted by mini-css-extract-plugin
export var bold = "P-module--bold--bbb62";
export var center = "P-module--center--52185";
export var marginBottomL = "P-module--marginBottomL--d9ba4";
export var marginBottomM = "P-module--marginBottomM--18034";
export var marginBottomS = "P-module--marginBottomS--77df8";
export var marginBottomXs = "P-module--marginBottomXs--d6000";
export var marginBottomXxs = "P-module--marginBottomXxs--39b7d";
export var sizeL = "P-module--sizeL--4210d";
export var sizeM = "P-module--sizeM--5efd4";
export var sizeS = "P-module--sizeS--077c2";
export var sizeXL = "P-module--sizeXL--79959";